import { Path, Svg, View } from '../../compiler'

const SummaryIcon = ({ style }) => (
  <View
    style={[
      {
        borderRadius: 6,
        height: 40,
        width: 40,
        backgroundColor: '#DFE4FC',
        alignItems: 'center',
        justifyContent: 'center'
      },
      style
    ]}
  >
    <Svg
      width='40'
      height='40'
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <Path
        d='M20 10.625C16.203 10.625 13.125 13.703 13.125 17.5C13.125 20.0423 14.5053 22.2615 16.5543 23.4504C17.1255 23.7818 17.4832 24.2903 17.4994 24.8021C17.5083 25.0844 17.7055 25.3257 17.9803 25.3906C18.2732 25.4598 18.5715 25.5143 18.8747 25.5532C19.1443 25.5879 19.3752 25.3719 19.3752 25.1V21.2158C19.1091 21.1864 18.8484 21.1383 18.5944 21.073C18.2601 20.9869 18.0588 20.6462 18.1449 20.3119C18.2309 19.9776 18.5717 19.7764 18.9059 19.8624C19.2549 19.9522 19.6215 20.0002 20.0002 20.0002C20.3788 20.0002 20.7454 19.9522 21.0944 19.8624C21.4286 19.7764 21.7694 19.9776 21.8554 20.3119C21.9415 20.6462 21.7402 20.9869 21.4059 21.073C21.1519 21.1383 20.8912 21.1864 20.6252 21.2158V25.0999C20.6252 25.3718 20.856 25.5879 21.1257 25.5532C21.4287 25.5143 21.727 25.4598 22.0197 25.3906C22.2945 25.3257 22.4917 25.0844 22.5006 24.8021C22.5168 24.2903 22.8745 23.7818 23.4457 23.4504C25.4947 22.2615 26.875 20.0423 26.875 17.5C26.875 13.703 23.797 10.625 20 10.625Z'
        fill='#2C46B2'
      />
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M17.511 26.583C17.5753 26.2439 17.9024 26.0211 18.2415 26.0855C18.8106 26.1934 19.3984 26.25 20 26.25C20.6016 26.25 21.1894 26.1934 21.7585 26.0855C22.0977 26.0211 22.4247 26.2439 22.4891 26.583C22.5534 26.9222 22.3306 27.2492 21.9915 27.3136C21.3459 27.436 20.6802 27.5 20 27.5C19.3199 27.5 18.6541 27.436 18.0085 27.3136C17.6694 27.2492 17.4466 26.9222 17.511 26.583Z'
        fill='#2C46B2'
      />
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M18.1284 28.62C18.1643 28.2767 18.4717 28.0275 18.815 28.0634C19.2043 28.1041 19.5996 28.125 20 28.125C20.4004 28.125 20.7957 28.1041 21.185 28.0634C21.5283 28.0275 21.8357 28.2767 21.8716 28.62C21.9075 28.9633 21.6583 29.2707 21.315 29.3066C20.8827 29.3518 20.4439 29.375 20 29.375C19.5561 29.375 19.1173 29.3518 18.685 29.3066C18.3417 29.2707 18.0925 28.9633 18.1284 28.62Z'
        fill='#2C46B2'
      />
    </Svg>
  </View>
)

export default SummaryIcon
